import React, { useState } from "react";
import { Modal, DialogContent } from "@mui/material";

import { ProjectRouteContainer } from "../../../project";
import { Button, Button2 } from "../../../ui/buttons";
import {
  ModalContent,
  ModalFooter,
  ModalPrompt,
  Tile,
} from "../../../ui/containers";
import { GenericField } from "../../../ui/inputs2";
import { InteractiveTable } from "../../../ui/table";

import q from "query-it";

import { useAllProjects } from "../../../../hooks/projects";

export default ({ user }) => {
  const [addingProject, setAddingProject] = useState(false);
  const [newProjectName, setNewProjectName] = useState("");

  const [projects, newProject] = useAllProjects();

  return (
    <ProjectRouteContainer>
      <Modal
        open={addingProject}
        onClose={() => {
          setAddingProject(false);
        }}
      >
        <DialogContent>
          <ModalPrompt>
            <ModalContent>
              <GenericField
                label={"Project Name"}
                data={newProjectName}
                onChange={(e) => {
                  const { value } = e.target;
                  setNewProjectName(value);
                }}
              />
            </ModalContent>
            <ModalFooter>
              <Button
                text={"Create"}
                onClick={() =>
                  newProject(newProjectName).then((_) => {
                    setNewProjectName("");
                    setAddingProject(false);
                  })
                }
              />
            </ModalFooter>
          </ModalPrompt>
        </DialogContent>
      </Modal>
      <Tile>
        <Button2
          label="Add Project"
          onClick={() => {
            setAddingProject(true);
          }}
          style={{ width: "fit-content", marginBottom: "10px" }}
        />
        <InteractiveTable
          data={projects}
          columns={[
            { name: "Name", index: "name" },
            {
              name: "Add self to project",
              component: (row) => (
                <Button2
                  onClick={async () => {
                    console.log("Adding a user to the project");
                    let result = null;
                    try {
                      result = await q.projects
                        .project(row.id)
                        .users.doc(user.ref.id)
                        .set({});
                    } catch (e) {
                      console.error("Error: " + e);
                    }
                    
                    /* Badges now handled in the backend, but lets keep this around in case self add does something strange
                    //Grab the project badges
                    let projectBadgesDoc = await q.projects
                      .project(row.id)
                      .defaultBadges.get();

                    //Add in the project id to the badge
                    let projectBadgesWithProjectId = [];
                    projectBadgesDoc.forEach((doc) => {
                      projectBadgesWithProjectId.push({
                        ...doc,
                        projectId: row.id,
                      });
                    });

                    //Get the current user badges
                    let userBadges = (await user.get()) || [];

                    //Update the users badges to include current and new badges from project
                    if (userBadges.badges) {
                      user.update({
                        badges: [
                          ...userBadges?.badges,
                          ...projectBadgesWithProjectId,
                        ],
                      });
                    } else {
                      user.update({
                        badges: [...projectBadgesWithProjectId],
                      });
                    }
                    */

                    console.log("Successfully Added user to project: ");
                  }}
                  label="Add"
                />
              ),
            },
            {
              name: "Add self to project silently",
              component: () => <p>woof</p>,
            },
          ]}
          allowOrdering={true}
        // CollapseComponent={(row) => <UserEditForm user={row} users={[]} /> }
        />
      </Tile>
    </ProjectRouteContainer>
  );
};

const ProjectEditForm = () => {
  return <>Edit the Project</>;
};
